import { ReactNode } from 'react';

import s from '../Stepper.module.scss';

export const Content = ({ hasStepLine = true, children }: { hasStepLine?: boolean; children?: ReactNode }) => {
  return (
    <div className="align-items-center flex gap-3.5">
      <div className={s.step_line}>{hasStepLine && <div className="h-full w-0.5 bg-gray-200" />}</div>
      <div className={s.content}>{children}</div>
    </div>
  );
};
